export default __webpack_public_path__ + "static/media/Low-Contact-Dentistry.b43cde08.png";